export const Routes = {
    home: '/',
    browse: '/browse',
    search: '/search',
    searchByType: '/search/:type',
    advancedSearch: '/advanced-search',
    collectionById: '/collection/:collectionId',
    featuredCollection: '/collections/featured/:viewId',
    mediaId: '/media/:id',
    mediaInfoId: '/media/info/:id',
    mediaRelatedId: '/media/related/:id',
    mediaRelatedForHoldSuccess: '/media/relatedforholdsuccess/:mediaId',
    mediaInfo: '/media/info',
    mediaAvailabilityId: '/media/availability/:id',
    mediaDownload: '/media/download/:format/:mediaId',
    mediaBorrow: '/media/borrow/:mediaId',
    mediaBorrowStatus: '/media/loans/:mediaId/:libraryKey',
    mediaReturn: '/media/return/:mediaId',
    mediaHoldStatus: '/media/holds/status/:mediaId',
    getSingleHold: '/media/hold/:mediaId',
    mediaPlaceHold: '/media/hold',
    mediaEditHold: '/media/holds/edit/:mediaId',
    mediaSuspendHold: '/media/holds/suspend/:mediaId',
    mediaRemoveHoldSuspension: '/media/holds/suspend/remove/:mediaId',
    mediaRemoveHold: '/media/holds/remove/:mediaId',
    accountSettings: '/account/settings',
    accountWishlist: '/account/lists/wishlist',
    accountWishlistStatus: '/account/lists/wishlist/status/:mediaId/:libraryKey',
    accountWishlistRemove: '/account/lists/wishlist/remove/:mediaId',
    accountWishlistAdd: '/account/lists/wishlist/add/:mediaId',
    supportMembers: '/support/members',
    supportCard: '/support/card',
    accountHolds: '/account/holds',
    accountInvalidCard: '/account/card/invalid',
    accountLoans: '/account/loans',
    accountLinkCard: '/account/linkcard',
    accountGetACard: '/account/sign-in?intent=gac',
    accountStartCardLink: '/account/initiate-card-link',
    accountSignIn: '/account/sign-in',
    accountSignInComplete: '/account/sign-in/complete',
    accountSignout: '/account/sign-out',
    appAuthenticate: '/account/app-authenticate',
    ozone: {
        signIn: '/account/ozone/sign-in',
        authenticate: '/account/signInOzone',
        accountSignoutComplete: '/account/sign-out/complete',
        external: '/account/ozone/external',
    },
    accountVerifyLinkedCards: '/account/verify-linked-card',
    accountLinkLibraryCardComplete: '/account/link-library-card/complete',
    patronEmail: '/patron/email',
    patronLendingPeriod: '/patron/media/lendingPeriods/:mediaId',
    dlrRoom: '/dlr-room',
    dlrAuthenticate: '/BANGAuthenticate.dll',
    dlrMediaId: '/ContentDetails.htm',
    seriesByTitle: '/series-by-title/:mediaId',
    updateHoldSettings: '/media/holds/settings',
    getBranches: '/branches',
    preferences: '/preferences',
    lendingSettings: '/lending-settings',
    reviews: '/media/reviews/:mediaId',
    relatedCarousel: '/media/relatedTitlesCarousel/:id',
    accountHistory: '/account/history',
    rest: {
        account: {
            get: '/rest/account/',
            limits: '/rest/account/limits',
            authLocal: '/rest/account/authenticate/local',
        },
        collections: {
            getById: '/rest/collections/:id',
        },
        media: {
            index: '/rest/media',
            related: '/rest/media/:id/relatedTitles',
            relatedTitlesPage: '/rest/media/:id/relatedTitlesPage',
            availableRelated: '/rest/media/:id/availableRelatedTitles',
            recentIssues: '/rest/media/recentIssues/:id',
        },
        subjects: {
            getGroupedByParent: '/rest/subjects/byparent',
            getCountByMediaType: '/rest/subjects/countby/mediatype',
        },
        search: {
            collectionMetadata: '/rest/search/collectionMetadata',
        },
        readingHistory: {
            index: '/rest/readingHistory',
            title: '/rest/readingHistory/title/:id',
            settings: '/rest/readingHistory/settings',
            export: '/rest/readingHistory/export',
        },
        rooms: {
            get: '/rest/rooms/:roomId',
        },
        campaigns: {
            get: '/rest/campaigns/:campaignId',
            getFirstDisplayable: '/rest/campaign/firstDisplayable/:roomId',
        },
        preferences: {
            global: {
                index: '/rest/preferences/global/',
            },
        },
        idc: {
            phone: {
                sendCode: '/rest/idc/phone/send-code',
                signUp: '/rest/idc/phone/sign-up',
                verifyCode: '/rest/idc/phone/verify-code',
            },
            geo: {
                authorize: '/rest/idc/geo/authorize',
            },
            email: {
                sendCode: '/rest/idc/email/send-code',
                verifyCode: '/rest/idc/email/verify-code',
            },
            signUp: '/rest/idc/sign-up',
        },
        holds: {
            available: '/rest/holds/available',
        },
    },
    assets: {
        css: {
            versionedColors: '/assets/v3/css/:version/colors.css',
        },
    },
    fulfillmentError: '/fulfillmentError',
    mergedSite: '/merged',
    odAppSunset: '/odAppSunset',
    terminatedSite: '/terminated',
    tlsSite: '/tls',
    publicApiFulfillment: {
        index: '/fulfillment/:reserveId',
        getDownloadLink: '/download/:format/:mediaId',
        getDownloadRedirect: '/fulfillment/download-redirect/:format/:mediaId',
        getMedia: '/fulfillment/media/:format/:mediaId',
    },
    api: {
        library: '/api/library',
        reporting: {
            ajaxError: '/api/reporting/ajaxError',
        },
    },
    kanopy: {
        noSubscription: '/kanopy/no-subscription',
        promo: '/getkanopy',
    },
    ntc: {
        detail: '/extras/:slug',
        faq: '/extras/faq',
        index: '/extras',
        api: {
            provider: '/api/extras/providers/:slug',
            providers: '/api/extras/providers',
            autoRedirect: '/api/extras/auth/redirect',
            autoPostForms: '/api/extras/auth/autoPost',
        },
        signIn: '/extras/sign-in',
    },
};
